import { Component } from '@theme/component';

class BbdProductFeatures extends Component {
  #mediaItems = [];
  #detailsList = [];
  #boundOnToggle = null;

  connectedCallback() {
    super.connectedCallback();

    this.#mediaItems = Array.from(this.querySelectorAll('.bbd-product-features__media-item'));
    this.#detailsList = Array.from(this.querySelectorAll('.bbd-product-features__accordions details'));

    this.#boundOnToggle = (event) => this.#onToggle(event);
    for (const d of this.#detailsList) {
      d.addEventListener('toggle', this.#boundOnToggle);
    }

    const opened = this.#detailsList.find((d) => d.open);
    const featureId = opened?.getAttribute('data-accordion-feature-id');
    if (featureId) this.#activateMedia(featureId);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#boundOnToggle) {
      for (const d of this.#detailsList) {
        d.removeEventListener('toggle', this.#boundOnToggle);
      }
    }
  }

  #onToggle = (event) => {
    const el = event.target;
    if (!(el instanceof HTMLDetailsElement)) return;
    if (!el.open) return; // react only when one opens

    const index = el.getAttribute('data-index');
    if (!index) return; // only act when a feature id is present
    this.#activateMedia(index);
  };

  #activateMedia(index) {
    let matched = false;
    for (const item of this.#mediaItems) {
      const isMatch = item.getAttribute('data-index') === String(index);
      item.classList.toggle('active', isMatch);
      if (isMatch) matched = true;
    }

    if (!matched && this.#mediaItems[0]) {
      this.#mediaItems[0].classList.add('active');
    }
  }
}

if (!customElements.get('bbd-product-features')) {
  customElements.define('bbd-product-features', BbdProductFeatures);
}
